import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { AuthenticationService } from '../../../services/authentication/authentication.service';
import { Route, Router, NavigationEnd, ActivatedRoute, ActivationStart, RoutesRecognized, ActivationEnd } from '@angular/router';
import { uniqBy } from 'lodash';
import { filter, mergeMap } from 'rxjs/operators';

import { GoogleTagManager } from 'src/shared/google-tag-manager/google-tag-manger';
import { NavTrackingService, NavItem } from '../../../services/common/nav-tracking.service';
import { Broker } from '../../models/broker';
import { SpinnerService } from '../../../services/common/spinner.service';

@Component({
  selector: 'ftl-quote-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  isIframe: boolean = false;

  pageTitle: string = "";
  pageRouteName: string = "";
  navRoutes: Route[] = [];
  currentNavOrder: number;
  isReturnRate: boolean = false;
  asyncCallInProgress: boolean = false;

  primaryBroker: Broker = new Broker();
  ftlAssistanceMessage = `Need Assistance? Contact your FTL representative at (800) 580-3101`;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private spinnerService: SpinnerService,
    private cdRef: ChangeDetectorRef,
    private navTrackingService: NavTrackingService
  ) {
    router.events.pipe(
      filter(e => e instanceof NavigationEnd))
      .forEach(e => {
        this.primaryBroker = activatedRoute.root.firstChild.snapshot.data['broker'];
        this.pageTitle = activatedRoute.root.firstChild.snapshot.data['title'];
        this.pageRouteName = activatedRoute.root.firstChild.snapshot.url[0] ? activatedRoute.root.firstChild.snapshot.url[0].toString() : '';
        let path = this.activatedRoute.root.firstChild.snapshot.url[0] ? this.activatedRoute.root.firstChild.snapshot.url[0].path : '';
        //this.quoteId = activatedRoute.root.firstChild.snapshot.params['quoteId'];
        this.currentNavOrder = activatedRoute.root.firstChild.snapshot.data['navOrder'];
        GoogleTagManager.sendPageViewEvent(path, this.getGTMPageTitle(this.pageTitle));
        this.navTrackingService.setNavigationState(new NavItem(this.currentNavOrder, path, this.activatedRoute.root.firstChild.snapshot.params));
        this.isReturnRate = this.pageRouteName == 'returnRate' ? true : false;
        this.navRoutes = uniqBy(router.config
          .filter(route => this.filterNavItems(route))
          .sort((r1, r2) => r1.data.navOrder - r2.data.navOrder), 'data.navOrder');
      });
  }

  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;
    
    this.spinnerService.isLoading.subscribe(data => {
      this.asyncCallInProgress = data;
      this.cdRef.detectChanges();
    });
  }

  filterNavItems(route) {
    if (route.data && route.data.navOrder) {
      const isTender = this.router.url.indexOf('Tender') > 0 ? true : false;
      if (isTender) {
        return !route.data.hideFromBar
      } else {
        return !route.data.hideFromBar && route.data.navTitle !== "Review"
      }
    }
    return false
  }

  getGTMPageTitle(pageTitle: string) {
    if (!pageTitle) {
      return '';
    } else {
      return pageTitle + ' - Customer';
    }
  }

  public navigateToRoute(route: Route): void {
    //place holder to fix build
  }
}
